<template>
  <esg-base-dashboard-card title="협력사 온실가스 배출량 정보 제출 (월별)">
    <template #actions>
      <b-col cols="12"
             lg="12"
             md="12">
        <b-row align-h="end">
          <b-form-group
              label-align="right"
              label-size="sm"
              content-cols="auto"
              class="mb-1 mb-sm-0 text-nowrap justify-content-end">
            <b-input-group size="sm">
              <b-form-select v-model="businessLoc"
                             size="sm">
                <option disabled="true"
                        :value="'all'">주거래 사업장
                </option>
                <option :value="'all'">ALL</option>
                <option :value="'울산고무공장'">울산 고무공장</option>
                <option :value="'당진고무공장'">당진 고무공장</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
          <b-form-group
              content-cols="auto"
              class="mb-0 text-nowrap justify-content-end">
            <b-input-group size="sm">
              <b-form-select v-model="status"
                             size="sm">
                <option disabled="true"
                        :value="'all'">진척현황
                </option>
                <option :value="'all'">ALL</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-row>
      </b-col>
    </template>
    <esg-base-chart>
      <apexchart type="bar"
                 height="250"
                 :options="chartOptions"
                 :series="series"/>
    </esg-base-chart>
  </esg-base-dashboard-card>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  name: 'CT00039',
  props: ['data'],
  components: {
    EsgBaseChart,
    apexchart: VueApexCharts, EsgBaseDashboardCard
  },
  data() {
    return {
      businessLoc: 'all',
      status: 'all',
      series: [],
      chartOptions: {
        chart: {
          type: 'bar',
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top', // top, center, bottom
            },
            columnWidth: '30%'
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, options) {
            // let percentage = Math.round(val / options.config.series[0].data.reduce((sum, current) => sum + current, 0) * 100, 0)
            return `${val} `;
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ["#304758"]
          }
        },

        xaxis: {
          position: 'bottom',
          categories: ["3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월", "1월", "2월"],
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          tooltip: {
            enabled: false,
          },
          crosshairs: {
            show: false
          }
        },
        yaxis: {
          show: false,
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
            formatter: function (val) {
              return val + "%";
            }
          },
          crosshairs: {
            show: false
          }
        },
        responsive: [
          {
            breakpoint: 1250,
            options: {
              chart: {height: 300, width: 650},
            }
          },
          {
            breakpoint: 992,
            options: {
              chart: {height: 300, width: 700},
            }
          },
          {
            breakpoint: 768,
            options: {
              chart: {height: 300, width: 450},
            }
          },
          {
            breakpoint: 576,
            options: {
              chart: {height: 300, width: 350},
            }
          },
        ],
        grid: {show: false},
      },
    }
  },
  created() {
    this.series = [{
      name: '',
      data: [12, 18, 34, 12, 26, 56, 5, 8, 45, 25, 4, 4]
    }]

  },
  watch: {
    data: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.setSeries();
          this.setLabels();
        }
      }
    }
  },
  methods: {
    async setSeries() {
      // 시각화 데이터 추출
      this.series = this.data.map(obj => obj.values);

    },
    async setLabels() {
      // 시각화 레이블 추출
      this.chartOptions.labels = this.data.map(obj => `Scope ${obj.scope}`);
    },
  }
}
</script>
